import { defineComponent as _defineComponent } from 'vue'
import { usesBillingPages } from '@/helpers/appContext';
import { Company } from '@/models/Company';
import router from '@/router';
import { HOME } from '@/routerNames';
import store from '@/store';
import { computed, onMounted, ref } from 'vue';
import moment from 'moment/moment';
import { Loading } from 'element-ui';
import { BillingHistoryItem } from '@/@types/billing/BillingHistoryItem';
import PaidStatusBadge from '@/components/billing/PaidStatusBadge.vue';
import MyTable from '@/components/layout/MyTable/MyTable.vue';
import MyTableCell from '@/components/layout/MyTable/MyTableCell.vue';
import apiService from '@/services/ApiService';
import notificationService from '@/services/NotificationService';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingHistoryPage',
  setup(__props) {

const tableColumns = [
  { label: 'INVOICE', sortBy: ['productName'] },
  { label: 'DATE', sortBy: ['date'] },
  { label: 'COST PER USER' },
  { label: 'USERS' },
  { label: 'AMOUNT' },
  { label: 'STATUS' },
  { label: '' },
  { label: '' },
];

const transactions = ref<BillingHistoryItem[]>([]);

const company = computed((): Company => store.state.company);

const isStatusCompleted = (status: string) => {
  return status === 'completed' || status === 'paid';
};

const handleDownloadInvoice = async (transactionId: string) => {
  const loader = Loading.service({ lock: true });

  try {
    const { data } = await apiService.billing.getTransactionInvoice(transactionId);
    window.open(data.url);
  } catch (e) {
    notificationService.warning((e as AxiosError<{ error: string }>)?.response?.data?.error);
  }

  loader.close();
  loader.$destroy();
};

const handleRefreshTransaction = async (transactionId: string) => {
  const loader = Loading.service({ lock: true });

  try {
    const { data } = await apiService.billing.getBillingHistoryItem(transactionId);

    transactions.value = transactions.value.map((transaction) =>
      transaction.transactionId === transactionId ? data : transaction
    );
  } catch (e) {
    apiService.handleResponseError(e);
  }

  loader.close();
  loader.$destroy();
};

const humanTransactionDate = (date: string | Date): string => {
  return moment(date).format('MMM D, YYYY');
};

const loadHistory = async () => {
  const loader = Loading.service({ lock: true });

  try {
    const { data } = await apiService.billing.getBillingHistory();
    transactions.value = data;
  } catch (e) {
    apiService.handleResponseError(e);
  }

  loader.close();
  loader.$destroy();
};

onMounted(async () => {
  if (!usesBillingPages(company.value)) {
    await router.push({ name: HOME });
    return;
  }

  await loadHistory();
});

return { __sfc: true,tableColumns, transactions, company, isStatusCompleted, handleDownloadInvoice, handleRefreshTransaction, humanTransactionDate, loadHistory, PaidStatusBadge, MyTable, MyTableCell }
}

})